import api from '../api';

const path = `/active`;

const getActiveSellRequest = () => api.get(`${path}/sell/get`);
const getActiveRentRequest = () => api.get(`${path}/rent/get`);
const getActiveCheckautoRequest = () => api.get(`${path}/checkauto/get`);
const getActivePartsRequest = () => api.get(`${path}/parts/get`);
const getActivePlacementRequest = () => api.get(`${path}/placement/get`);
const getActiveServicesRequest = () => api.get(`${path}/services/get`);

export {
    getActiveSellRequest,
    getActiveRentRequest,
    getActiveCheckautoRequest,
    getActivePartsRequest,
    getActivePlacementRequest,
    getActiveServicesRequest,
};
